import _axios from '@/util/httpConfig.js'

// 获取办理流程的contentCode
export const getHandlingProcess = (moduleCode) => {
  let data = {
    moduleCode,
    tenantCode: '96F307B9D0EDF9F',
    appCode: 'APPAFBB8CD316AFF62',
    pageNo: 0,
    pageSize: 0,
    status: '',
    typeCode: ''
  }
  return _axios("POST", `/common-content/contentAnnounce/list`, data)
}
export const getSpecificContent = (contentCode) => {
  return _axios('GET', `common-content/contentAnnounce/get?contentCode=${contentCode}&tenantCode=96F307B9D0EDF9F`)
}


// 获取表格数据
export const getTable = (type = '', code) => {
  const data = {
    "appCode": "APPAFBB8CD316AFF62",
    "contentStatus": "",
    "fileName": "",
    "moduleCode": code,
    "moduleNavCode": "",
    "pageNo": 1,
    "pageSize": 999,
    "status": "",
    "tenantCode": "96F307B9D0EDF9F",
    "typeCode": type
  }
  return _axios('POST', '/common-content/contentDownload/list', '', data)
}
// 获取签证资讯标题
export const getInfoTitle = () => {
  const data = {
    appCode: "APPAFBB8CD316AFF62",
    moduleName: "",
    pageNo: 0,
    pageSize: 1000,
    parentResourceCode: "RESC47251EA8724CE4",
    resourceName: "",
    status: "E",
    tenantCode: "96F307B9D0EDF9F"
  }
  return _axios('POST', '/common-content/contentModule/list', '', data)
}
// 获取签证信息
export const getInfo = (type = '', moduleCode = 'RESD2F68E16A9669D5') => {
  const data = {
    "appCode": "APPAFBB8CD316AFF62",
    "contentStatus": "",
    "contentTitle": "",
    "moduleCode": moduleCode,
    "moduleNavCode": "",
    "pageNo": 0,
    "pageSize": 666,
    "status": "",
    "tenantCode": "96F307B9D0EDF9F",
    "typeCode": type
  }
  return _axios('POST', '/common-content/contentAnnounce/list', '', data)
}
// 获取列表类型数据
export const getListData = (moduleCode) => {
  const data = {
    "appCode": "APPAFBB8CD316AFF62",
    "contentStatus": "",
    "contentTitle": "",
    "moduleCode": moduleCode,
    "moduleNavCode": "",
    "pageNo": 0,
    "pageSize": 666,
    "status": "",
    "tenantCode": "96F307B9D0EDF9F",
    "typeCode": ''
  }
  return _axios('POST', '/common-content/contentAnnounce/list', '', data)
}
// 获取文本类型数据
export const getText = (moduleCode) => {
  const data = {
    "appCode": "APPAFBB8CD316AFF62",
    "contentStatus": "",
    "contentTitle": "",
    "moduleCode": moduleCode,
    "moduleNavCode": "",
    "pageNo": 0,
    "pageSize": 0,
    "status": "",
    "tenantCode": "96F307B9D0EDF9F",
    "typeCode": ""
  }
  return _axios('POST', '/common-content/contentAnnounce/list', '', data)
}
// 获取联系方式
// 获取常见问题详情
export const getConnect = () => {
  return _axios('GET', `/common-content/contentAnnounce/get?contentCode=RESEA620424D880B51&tenantCode=96F307B9D0EDF9F`)
}
// 获取常见问题
export const getIssue = () => {
  const data = {
    "appCode": "APPAFBB8CD316AFF62",
    "contentStatus": "",
    "contentTitle": "",
    "moduleCode": "RES4FFAE599DE68D42",
    "moduleNavCode": "",
    "pageNo": 0,
    "pageSize": 4,
    "status": "",
    "tenantCode": "96F307B9D0EDF9F",
    "typeCode": ""
  }
  return _axios('POST', '/common-content/contentAnnounce/list', '', data)
}
// 获取常见问题详情
export const getIssueDetail = (contentCode, tenantCode) => {
  return _axios('GET', `/common-content/contentAnnounce/get?contentCode=${contentCode}&tenantCode=${tenantCode}`)
}
// 获取赴日须知
export const getNeedKnow = () => {
  const data = {
    "appCode": "APPAFBB8CD316AFF62",
    "contentStatus": "",
    "contentTitle": "",
    "moduleCode": "RES82B0F4428490544",
    "moduleNavCode": "",
    "pageNo": 0,
    "pageSize": 4,
    "status": "",
    "tenantCode": "96F307B9D0EDF9F",
    "typeCode": ""
  }
  return _axios('POST', '/common-content/contentAnnounce/list', '', data)
}
// 获取赴日须知详情
export const getNeedKnowDetail = (contentCode, tenantCode) => {
  return _axios('GET', `/common-content/contentAnnounce/get?contentCode=${contentCode}&tenantCode=${tenantCode}`)
}
// 获取国家信息
export const getNationalFlag = (type = '', picName) => {
  const data = {
    "appCode": "APPAFBB8CD316AFF62",
    "moduleCode": "RES325EB7A0A4F89F3",
    "moduleNavCode": "",
    "pageNo": 1,
    "pageSize": 999,
    "picName": picName,
    "picStatus": "",
    "status": "",
    "tenantCode": "96F307B9D0EDF9F",
    "typeCode": type
  }
  return _axios('POST', '/common-content/contentPic/list', '', data)
}
// 获取国家图片
export const getNationalPhoto = (picCode, tenantCode) => {
  return _axios('GET', `/common-content/contentPic/get?picCode=${picCode}&tenantCode=${tenantCode}`)
}
// 各国内页
export const getNationalDetails = (moduleCode) => {
  const data = {
    "appCode": "APPAFBB8CD316AFF62",
    "contentStatus": "",
    "contentTitle": "",
    "moduleCode": moduleCode,
    "moduleNavCode": "",
    "pageNo": 0,
    "pageSize": 0,
    "status": "",
    "tenantCode": "96F307B9D0EDF9F",
    "typeCode": ""
  }
  return _axios('POST', `/common-content/contentAnnounce/list`, '', data)
}
//各国图片
export const getNationalDetailsPic = (moduleCode) => {
  const data = {
    "appCode": "APPAFBB8CD316AFF62",
    "contentStatus": "",
    "contentTitle": "",
    "moduleCode": moduleCode,
    "moduleNavCode": "",
    "pageNo": 0,
    "pageSize": 0,
    "status": "",
    "tenantCode": "96F307B9D0EDF9F",
    "typeCode": ""
  }
  return _axios('POST', `/common-content/contentPic/list`, '', data)
}


// 获取签证信息
export const getList = (type = '', moduleCode = 'RESD2F68E16A9669D5') => {
  const data = {
    "appCode": "APPAFBB8CD316AFF62",
    "contentStatus": "",
    "contentTitle": "",
    "moduleCode": moduleCode,
    "moduleNavCode": "",
    "pageNo": 0,
    "pageSize": 666,
    "status": "",
    "tenantCode": "96F307B9D0EDF9F",
    "typeCode": type
  }
  return _axios('POST', '/common-content/contentAnnounce/list', '', data)
}


// 获取签证类型
export const getQZLXList = () => {
  return _axios('GET', '/common-api/visa/getVisaStair?visaTypeCode=QZLX')
}

// 获取探亲类别
export const getTQLBList = (data) => {
  return _axios('GET', '/common-api/visa/getVisaSecond?tenantCode=96F307B9D0EDF9F&visaType=' + data)
}

// 获取可预约时间
export const getAttentionDate = () => {
  return _axios('GET', '/common-api/visa/reserveConfig/date/droplist?tenantCode=96F307B9D0EDF9F')
}

// 获取可预约时间
export const getAttentionTime = (data) => {
  return _axios('GET', '/common-api/visa/reserveConfig/time/droplist?tenantCode=96F307B9D0EDF9F&visaType=0&reserveDate=' + data)
}

// 预约信息提交
export const reserveOrder = (data) => {
  return _axios('POST', '/common-api/visa/reserveOrder', data)
}

// 预约信息回显
export const getdetail = (data) => {
  return _axios('GET', `/common-api/visa/reserveOrder/detail?tableDataId=${data}`)
}


// 预约信息回显
export const orderReserve = (name, passportId, reserveDate1) => {
  return _axios('GET', `/common-api/visa/orderReserve/pages?name=${name}&passportId=${passportId}&reserveDate1=${reserveDate1}&verifyStatus=0`)
}


// 取消预约单
export const cancelOrder = (data) => {
  return _axios('PUT', `/common-api/visa/reserveOrder/cancel`, data)
}

///api/common-api/visa/reserveOrder/cancel

// 材料预审

export const uploading = (data) => {
  return _axios('POST', `/common-api/visa/portalAntecedentTrial/uploading`, data)
}
// 材料预审查询
export const query = (name, passportId, phoneNumber) => {
  return _axios('GET', `/common-api/visa/portalAntecedentTrial/query?name=${name}&passportId=${passportId}&phoneNumber=${phoneNumber}`)
}

// 材料预审查询
export const fileShow = (fileCode) => {
  return _axios('GET', `/cloud-fastdfs/fastdfs/download/file/96F307B9D0EDF9F/4AD13C5F04995EA?fileCode=${fileCode}&time=1672800486197`)
}

// 我要查询
export const iWantToQuery = (name, passportId, handleOrderId) => {
  return _axios('GET', `/common-api/visa/iWantToQuery?name=${name}&passportId=${passportId}&handleOrderId=${handleOrderId}`)
}



// WEBPACK FOOTER //
// ./src/api/goaborad.js